// extracted by mini-css-extract-plugin
export default {"shopping-cart-links":"shopping-cart-links_v60361yF"};